import React, { useEffect, useRef, useState } from 'react';
import '../../assets/css/overview-updated.css';
import '../../assets/css/overview-requests.css';
import '../../assets/css/add-updated-modal.css';
import '../../assets/css/sign-off-request-modal.css';
import '../../assets/css/change-order-modal.css';
import '../../assets/css/new-additional-modal.css';
import leftArrow from '../../assets/img/white-left-icon.svg';
import editIcon from '../../assets/img/edit-pencil.svg';
import cross3 from '../../assets/img/cross3.svg';
import collapseIcon from '../../assets/img/collapse-icon.svg';
import dotsThreeIcon from '../../assets/img/DotsThree.svg';
import settingIcon from '../../assets/img/settings.svg';
import notificationIcon from '../../assets/img/notification.svg';
import bellIcon2 from 'assets/img/bell-01.svg';
import bellIcon from '../../assets/img/bell.svg';
import arrowDown from '../../assets/img/arrow-down.svg';
import timeIcon from '../../assets/img/time-icon.svg';
import KanbanIcon from '../../assets/img/khanban-icon.svg';
import whiteArro from '../../assets/img/white-arrow-down.svg';
import calenderIcon2 from '../../assets/img/calendar-date.svg';
import slackIcon from '../../assets/img/slack-svgrepo.svg';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Header from '../../components/Header';
import { Dropdown, ProgressBar } from 'react-bootstrap';
import UpdatedScope from './updatedoverviewtabs/UpdatedScope';
import APIServices from '../../services/APIServices';
import {
  calculateDateDifference,
  formatDate,
  getRemainingDays,
  hasPermission,
  isFutureDate,
  isPastDate,
  selectLoader
} from '../../utils/Helpers';
import ActivityTab from './updatedoverviewtabs/ActivityTab';
import RequestTab from './updatedoverviewtabs/RequestTab';
import appToast, { TOAST_TYPE } from '../../utils/AppToast';
import { useStore } from '../../hooks/useStore';
import { useAuth } from '../../contexts/AuthContext';
import FeedbackTab from './updatedoverviewtabs/FeedbackTab';
import connectIcon from '../../assets/img/connect-icon.svg';
import SidebarModal from '../../components/SidebarModal';
import Notifications from '../../components/Notifications';
import SignOffForm from './forms/SignOffForm';
import ProjectProgress from '../../components/ProjectProgress';
import ConfirmModal from '../../components/ConfirmModal';
import Tippy from '@tippyjs/react';
import ModalCenter from 'components/ModalCenter';
import {
  connectSlackActivity,
  dismissProjectSlackBanner,
  disconnectProjectSlackActivity,
  getProjectSlackActivityStatus
} from '../../utils/slackActivity';

// Slack integration is temporarily hidden from the UI.
const SHOW_SLACK_INTEGRATION = false;

const UpdatedOverview = ({ embedded = false, setProjectName = () => {} }) => {
  const { isUser1, user, userRole, socket } = useAuth();
  const hasFetchedRef = useRef(false);
  const projectIdRef = useRef('');
  const projectDataRef = useRef(null);
  const projectRequestSequenceRef = useRef(0);
  const milestoneStatusRequestInProgressRef = useRef(false);
  const closeProjectRequestInProgressRef = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [store, setStore] = useStore();
  const { notificationId, projectId: projectparentId } = useParams();
  const projectParamsId = location.state?.projectId || '';
  const openReqId = location.state?.openReqId || '';
  const [projectId, setProjectId] = useState('');
  const [scopeData, setScopeData] = useState(null);
  const [currentUserRole, setCurrentUserRole] = useState(userRole);
  const [notificationDetails, setNotificationDetails] = useState([]);
  const [projectStatus, setProjectStatus] = useState('ontime');
  const [updateDetails, setUpdateDetails] = useState(false);
  const [currentTab, setCurrentTab] = useState(1);
  const [memberPermission, setMemberPermission] = useState('Edit');
  const [activeTabView, setActiveView] = useState('');
  const [projectData, setProjectData] = useState(null);
  const [projectLoadError, setProjectLoadError] = useState('');
  const [milestones, setMilestones] = useState([]);
  const [pageLoading, setPageLoading] = useState(true); // State to track loading
  const [loading, setLoading] = useState(true); // State to track loading
  const [projectLoading, setProjectLoading] = useState(false); // State to track loading
  const [milestoneStatusOptions, setMilestoneStatusOptions] = useState([]); // State to track loading
  const [loadingMilestoneId, setLoadingMilestoneId] = useState(null);
  const [changeOrders, setChangeOrders] = useState([]);
  const [activeQuotes, setActiveQuotes] = useState([]);
  const [changeRequests, setChangeRequests] = useState([]);
  const [selectedReqId, setSelectedReqId] = useState('');
  const [isUnread, setUnread] = useState(false);
  const [isClosedProject, setClosedProject] = useState(false);
  const [isInternalProject, setInternalProject] = useState(false);
  const [isClosingProject, setClosingProject] = useState(false);
  const [isAutoRenew, setAutoRenew] = useState(true);
  const [isPastEndDate, setPastEndDate] = useState(false);
  const [isRecurring, setRecurring] = useState(true);
  const [isFutureProject, setFutureProject] = useState(false);
  const [closedMilestoneId, setClosedMilestoneId] = useState('');
  const [currentTime, setCurrentTime] = useState(Date.now());
  const [projectTeam, setProjectTeam] = useState([]);
  const [projectSlackLoading, setProjectSlackLoading] = useState(false);
  const [showProjectSlackBanner, setShowProjectSlackBanner] = useState(false);
  const [projectSlackStatusLoadedFor, setProjectSlackStatusLoadedFor] = useState('');
  const [projectSlackStatus, setProjectSlackStatus] = useState({
    connected: false,
    lastSyncStatus: 'not_synced',
    lastSyncedAt: null,
    lastSyncError: '',
    teamName: '',
    channelName: '',
    bannerDismissed: false,
    hasConnectedBefore: false
  });
  const [modals, setModals] = useState({
    notifications: false,
    signOffModal: false,
    closeConfirmModal: false
  });
  const [collapsedSections, setCollapsedSections] = useState({
    running: false,
    upcoming: true,
    completed: true
  });

  const toggleSection = (section) => {
    setCollapsedSections((prev) => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const toggleModal = (modalType, isOpen) => {
    setModals((prevState) => ({
      ...prevState,
      [modalType]: isOpen
    }));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(Date.now());
    }, 1000); // Update every second

    return () => clearInterval(interval); // Clean up on unmount
  }, []);
  useEffect(() => {
    if (projectParamsId) {
      setProjectId(projectParamsId);
      projectIdRef.current = projectParamsId; // Keep ref updated
    } else if (projectparentId) {
      setProjectId(projectparentId);
      projectIdRef.current = projectparentId;
      if (notificationId) {
        fetchNotificationDetails();
      }
    }
  }, [projectParamsId, projectparentId]);

  // useEffect(() => {
  //   if (notificationId) {
  //     console.log(notificationId);
  //     fetchNotificationDetails();
  //   }
  // }, [notificationId]);

  // Fetch the scope details from the API
  const fetchNotificationDetails = async () => {
    try {
      const response = await APIServices.get(`/notification/${notificationId}`);
      if (response) {
        console.log('fetchNotificationDetails', selectedReqId);
        console.log(response.data);
        let notificationDetails = response.notificationTypeId;
        if (response.data.notificationType && response.data.notificationType.includes('quote')) {
          setSelectedReqId(response.data?.notificationTypeId?.projectRequestId?._id);
        } else {
          setSelectedReqId(response.data?.notificationTypeId?._id || '');
        }

        if (
          response.data?.notificationType?.includes('requested') ||
          response.data?.notificationType?.includes('given')
        ) {
          setCurrentTab(4);
        } else if (
          !notificationDetails?.requestType?.includes('activity') &&
          !response.data?.notificationType?.includes('update_made') &&
          !response.data?.notificationType?.includes('project_created') &&
          !response.data?.notificationType?.includes('activity') &&
          !response.data?.notificationType?.includes('mentioned_message') &&
          !response.data?.notificationType?.includes('milestone_started') &&
          !response.data?.notificationType?.includes('milestone_completed')
        ) {
          setCurrentTab(2);
        } else {
          setCurrentTab(1);
        }
        // fetchProjectData(response.projectId);
        console.log(response.data);

        setProjectId(response.data.projectId);
        setNotificationDetails(response.data); // Set the scope data in state
      }
    } catch (error) {
      console.error('Error fetching notification details:', error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch the scope details from the API
  const fetchScopeDetails = async (projectId) => {
    try {
      const response = await APIServices.get(`/project-scope?projectId=${projectId}`);
      if (response._id) {
        setScopeData(response); // Set the scope data in state
      }
    } catch (error) {
      console.error('Error fetching scope details:', error);
    } finally {
      setLoading(false);
    }
  };

  // Fetching project data from the backend
  const fetchProjectData = async (projectId) => {
    if (!projectId) {
      return;
    }
    const requestedProjectId = projectId.toString();
    const requestSequence = ++projectRequestSequenceRef.current;
    const isLatestProjectRequest = () =>
      requestSequence === projectRequestSequenceRef.current &&
      projectIdRef.current?.toString() === requestedProjectId;

    setProjectLoadError('');
    if (!projectDataRef.current) {
      setPageLoading(true);
    }
    setProjectLoading(true);
    try {
      // Using axios or fetch to get data from your API
      const response = await APIServices.get(`/project/${projectId}`); // API call with project ID
      if (!isLatestProjectRequest()) {
        return;
      }
      // console.log(response);
      if (response?.projectDetail) {
        projectDataRef.current = response.projectDetail;
        setProjectData(response.projectDetail); // Set the response data in state
        setMilestones(response.milestones);
        setChangeOrders(response.changeOrderRequests);
        setActiveQuotes(response.activeQuotes);
        setChangeRequests(response.changeRequests);
        setAutoRenew(response?.projectDetail?.isAutoRenew);
        setRecurring(response?.projectDetail?.isRecurring || false);
        if (response?.projectDetail?.endDate) {
          let isPast = isPastDate(response?.projectDetail?.endDate, true);
          setPastEndDate(isPast);
        }
        if (response?.projectTeam?.myTeam) {
          let projectTeamData = [...response?.projectTeam?.myTeam, ...response?.projectTeam?.organizationTeam];
          let updatedProjectTeam = projectTeamData.filter((member) => member.userId._id !== user._id);
          setProjectTeam(updatedProjectTeam);
          let userPermission;
          if (isUser1) {
            userPermission = response.projectTeam.myTeam.find((member) => member.userId._id === user._id);
          } else {
            userPermission = response.projectTeam.organizationTeam.find((member) => member.userId._id === user._id);
          }
          if (userPermission) {
            if (userPermission?.permission) {
              setMemberPermission(userPermission.permission.name);
            }
            setCurrentUserRole(userPermission?.role?.role);
            if (response?.projectDetail?.type === 'internal') {
              setInternalProject(true);
            }
          }
        }
        if (response.projectDetail?.latestUpdate[0]?.updateStatus?.value) {
          setProjectStatus(response.projectDetail?.latestUpdate[0]?.updateStatus?.value);
        }
        setClosedProject(response.projectDetail.projectStatus === 'closed');
        if (response.projectDetail.startDate) {
          setFutureProject(isFutureDate(response.projectDetail.startDate || new Date()));
        }
        setProjectName(response.projectDetail.projectName);
      } else {
        throw new Error(response?.data?.message || 'Unable to load this project. Please try again.');
      }
      setProjectLoading(false);
    } catch (error) {
      if (!isLatestProjectRequest()) {
        return;
      }
      console.error('Error fetching project data:', error);
      projectDataRef.current = null;
      setProjectData(null);
      setProjectLoadError(
        error?.response?.data?.message || error?.message || 'Unable to load this project. Please try again.'
      );
    } finally {
      if (isLatestProjectRequest()) {
        setProjectLoading(false);
        setPageLoading(false); // Stop loading even if there is an error
      }
    }
  };

  const fetchmileStoneStatus = async () => {
    try {
      const response = await APIServices.get(`/enum?item_type=milestonstatus`); // Adjust the URL as necessary
      if (response.length > 0) {
        setMilestoneStatusOptions(response);
      }
      setTimeout(() => {
        if (openReqId) {
          handleRequestDetails(openReqId, 2);
        }
      }, 500);
    } catch (error) {
      console.error('Error fetching permissions:', error);
    }
  };

  const handleBackClick = () => {
    navigate('/'); // This goes back to the previous page
  };

  const handleRequestDetails = (reqId, tabIndex) => {
    console.log('handleRequestDetails', reqId);
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    setSelectedReqId(reqId);
    setStore({ selectedReqId: reqId });
    setCurrentTab(tabIndex);
  };

  const updateandCloseModal = (modalType) => {
    setModals((prevState) => ({
      ...prevState,
      [modalType]: false
    }));
    // fetchActivities();
    setUpdateDetails((prev) => !prev);
  };

  useEffect(() => {
    if (projectId && user) {
      fetchProjectData(projectId);
      fetchScopeDetails(projectId);
      fetchmileStoneStatus(projectId);
      setStore({ projectId: projectId });
    }
    // else{
    //   navigate("/");
    // }
  }, [projectId, updateDetails, user]);

  useEffect(() => {
    if (!projectId || !user) return;

    projectIdRef.current = projectId;
    setShowProjectSlackBanner(false);
    setProjectSlackStatusLoadedFor('');
    fetchProjectSlackStatus(projectId);
  }, [projectId, user]);

  useEffect(() => {
    if (!socket || !projectId) return;

    const handleProjectSlackSyncUpdated = (payload) => {
      if (payload?.projectId?.toString() !== projectId?.toString()) return;
      updateProjectSlackStatus({
        ...projectSlackStatus,
        ...payload
      });
      if (payload?.connected) {
        setShowProjectSlackBanner(false);
      }
    };

    socket.on('ProjectSlackSyncUpdated', handleProjectSlackSyncUpdated);
    return () => {
      socket.off('ProjectSlackSyncUpdated', handleProjectSlackSyncUpdated);
    };
  }, [socket, projectId, projectSlackStatus]);

  const updateMilestoneStatus = async (milestoneId, updateType = 'inprogress') => {
    if (milestoneStatusRequestInProgressRef.current) {
      return;
    }

    milestoneStatusRequestInProgressRef.current = true;
    setLoadingMilestoneId(milestoneId); // Start loader for the milestone
    try {
      let currentStatusId = milestoneStatusOptions?.find((x) => x.value == updateType);
      if (!currentStatusId?._id) {
        appToast('Unable to update the milestone status. Please try again.', TOAST_TYPE.ERROR);
        return;
      }

      let payload = {
        statusId: currentStatusId?._id
      };

      const response = await APIServices.put(`/project-milestone/${milestoneId}/status`, payload);

      if (response.message) {
        appToast(response.message, TOAST_TYPE.SUCCESS);
        fetchProjectData(projectId);
      } else if (response.data.milestoneId) {
        setClosedMilestoneId(milestoneId);
        appToast(response.data.message, TOAST_TYPE.WARNING);
        toggleModal('signOffModal', true);
      } else {
        appToast(response.data.message, TOAST_TYPE.ERROR);
      }
    } catch (error) {
      console.error('Error updating team status:', error);
      appToast('Failed to update team status', TOAST_TYPE.ERROR);
    } finally {
      milestoneStatusRequestInProgressRef.current = false;
      setLoadingMilestoneId(null);
    }
  };
  const handleKanbanIconClick = () =>
    navigate(`/project-board/${projectId}`, {
      state: {
        isProjectRelatedBoard: true,
        showBack: true
      }
    }); // This goes back to the previous page
  const handleCloseProject = async (resetToToday = null) => {
    if (closeProjectRequestInProgressRef.current) {
      return;
    }

    closeProjectRequestInProgressRef.current = true;
    setClosingProject(true);
    // if (projectData.isRecurring) {
    // }
    try {
      let payload = {
        projectStatus: 'closed',
        ...(projectData.isRecurring && !isAutoRenew && resetToToday !== null && { resetToToday })
        // isAutoRenew
      };
      const response = await APIServices.put(`/project/${projectId}/status`, payload);
      if (response.message) {
        setClosedProject(true);
        appToast(response.message, TOAST_TYPE.SUCCESS);
        setUpdateDetails((prev) => !prev);
      } else if (response.data.message) {
        appToast(response.data.message, TOAST_TYPE.ERROR);
      }
    } catch (error) {
      // Handle errors
      appToast(error, TOAST_TYPE.ERROR);
    } finally {
      closeProjectRequestInProgressRef.current = false;
      toggleModal('closeConfirmModal', false);
      setClosingProject(false);
    }
  };
  const handleEditProject = (projectId) => {
    navigate(`/update-project/${projectId}`);
  };

  const updateProjectSlackStatus = (status = {}) => {
    setProjectSlackStatus({
      connected: Boolean(status?.connected),
      lastSyncStatus: status?.lastSyncStatus || 'not_synced',
      lastSyncedAt: status?.lastSyncedAt || null,
      lastSyncError: status?.lastSyncError || '',
      teamName: status?.teamName || '',
      channelName: status?.channelName || '',
      isActivitySyncEnabled: Boolean(status?.isActivitySyncEnabled),
      bannerDismissed: Boolean(status?.bannerDismissed),
      hasConnectedBefore: Boolean(status?.hasConnectedBefore || status?.connected)
    });
  };

  const fetchProjectSlackStatus = async (activeProjectId = projectId) => {
    if (!activeProjectId) return;

    try {
      const status = await getProjectSlackActivityStatus(activeProjectId);
      if (projectIdRef.current?.toString() !== activeProjectId?.toString()) return;

      updateProjectSlackStatus(status);
      setShowProjectSlackBanner(!status?.connected && !status?.bannerDismissed);
      setProjectSlackStatusLoadedFor(activeProjectId);
    } catch (error) {
      console.error('Unable to fetch project Slack status:', error);
    }
  };

  const handleProjectSlackToggle = async () => {
    if (projectSlackLoading || !projectId) return;

    setProjectSlackLoading(true);
    try {
      if (projectSlackStatus?.connected) {
        await disconnectProjectSlackActivity(projectId);
        appToast('Project Slack activity sync disconnected.', TOAST_TYPE.SUCCESS);
      } else {
        await connectSlackActivity({ projectId });
        setShowProjectSlackBanner(false);
        setProjectSlackStatus((prev) => ({
          ...prev,
          hasConnectedBefore: true
        }));
        appToast('Project Slack activity sync connected.', TOAST_TYPE.SUCCESS);
      }
      await fetchProjectSlackStatus(projectId);
    } catch (error) {
      console.error('Project Slack activity sync failed:', error);
      appToast(error.message || 'Unable to update project Slack activity sync.', TOAST_TYPE.ERROR);
    } finally {
      setProjectSlackLoading(false);
    }
  };

  const handleProjectSlackBannerClose = async () => {
    setShowProjectSlackBanner(false);
    if (!projectId) return;

    try {
      await dismissProjectSlackBanner(projectId);
      setProjectSlackStatus((prev) => ({
        ...prev,
        bannerDismissed: true
      }));
    } catch (error) {
      console.error('Unable to dismiss project Slack banner:', error);
    }
  };

  const groupMilestonesByMonth = (milestones = []) => {
    const groups = {};

    milestones.forEach((milestone) => {
      const rawDate = milestone.signoffDate || milestone.endDate || milestone.signoffApprovedDate || new Date();

      const date = new Date(rawDate);

      // sortable key → 2026-02, 2025-11, etc.
      const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;

      const label = date.toLocaleString(undefined, {
        month: 'long',
        year: 'numeric'
      });

      if (!groups[key]) {
        groups[key] = {
          label,
          date,
          items: []
        };
      }

      groups[key].items.push(milestone);
    });

    return groups;
  };

  useEffect(() => {
    // Listen for 'projectActivityUpdate' event
    if (socket) {
      const handle_Notification = (Notification) => {
        // scrollToBottom();
        setUnread(true);
        // console.log('Notification', Notification);
      };
      const handle_ProjectRequestQuote = (activity) => {
        if (activity?.projectId?.toString() !== projectIdRef.current?.toString()) {
          return;
        }

        if (!projectLoading) {
          fetchProjectData(projectIdRef.current);
        }
        fetchScopeDetails(projectIdRef.current);
        // console.log('ProjectRequestQuote', activity);
      };
      const handle_ProjectUpdate = (activity) => {
        if (!projectLoading && activity?.projectId === projectIdRef.current) {
          fetchProjectData(projectIdRef.current);
        }
        console.log('ProjectUpdate', activity);
      };
      const handle_ProjectRequest = (activity) => {
        if (!projectLoading && activity?.projectId === projectIdRef.current) {
          fetchProjectData(projectIdRef.current);
        }
        console.log('ProjectRequest', activity);
      };
      const handle_MilestoneUpdated = (activity) => {
        // if (!projectLoading) {
        if (activity?.projectId === projectIdRef.current) {
          fetchProjectData(projectIdRef.current);
        }
        // }
        // fetchProjectData(projectId);
        // console.log('MilestoneUpdated', activity);
      };
      socket?.on('Notification', handle_Notification);
      socket?.on('ProjectRequestQuote', handle_ProjectRequestQuote);
      socket?.on('ProjectUpdate', handle_ProjectUpdate);
      socket?.on('ProjectRequest', handle_ProjectRequest);
      socket?.on('MilestoneUpdated', handle_MilestoneUpdated);
      return () => {
        socket?.off('Notification', handle_Notification);
        socket?.off('ProjectRequestQuote', handle_ProjectRequestQuote);
        socket?.off('ProjectUpdate', handle_ProjectUpdate);
        socket?.off('ProjectRequest', handle_ProjectRequest);
        socket?.off('MilestoneUpdated', handle_MilestoneUpdated);
      };
    }
  }, [socket]);

  const closeConfirmContent =
    !isAutoRenew && isPastEndDate && isRecurring ? (
      <div>
        <h3 className="mb-3">The end date has already passed.</h3>
        <h3>Would you like to start the project from today or from the next recurrence date? </h3>
      </div>
    ) : (
      <div>
        <h2 className="mb-3">Confirm Project Closure</h2>
        <h3>Are you sure you want to request the closure of this project? </h3>
        <ul className="project-list-content">
          <li>The project will be frozen in its current state for historical reference.</li>
          <li>No further changes or updates will be allowed unless the project is reopened.</li>
          <li>This action cannot be undone without administrative approval.</li>
        </ul>
      </div>
    );

  const HeaderContent = (
    <>
      <div className="overview_header_top_div">
        <h2>Overview</h2>
        {projectData?.isDraft && <span className="draft-btn">Draft</span>}
      </div>
      <div className="head-right">
        {isUser1 && hasPermission(currentUserRole, 'update_projects') && (
          <div onClick={handleKanbanIconClick}>
            <Tippy content={'Happy Projects'} placement="top" arrow={true}>
              <img src={KanbanIcon} alt="kanban" style={{ cursor: 'pointer' }} />
            </Tippy>
          </div>
        )}
        {/* <a>
          <img
            src={settingIcon}
            alt="menu"
            className="feather-img menuicon"
            onClick={() => {
              navigate("/settings");
            }} // Sidebar toggle handler
          />
        </a> */}
        <div
          onClick={() =>
            navigate('/project-boards', {
              state: {
                isCalenderView: true
              }
            })
          }>
          <Tippy
            // content={`Color: ${namer(x.color).ntc[0].name}, title: ${x?.name}`}
            content={'My Calendar'}
            placement="top"
            arrow={true}>
            <img src={calenderIcon2} alt="menu" className="feather-img2 menuicon cursor_pointer" />
          </Tippy>
        </div>
        <Dropdown className="notify-drp">
          <Dropdown.Toggle
            as="a"
            className="dropdown-toggle"
            onClick={() => {
              toggleModal('notifications', true);
              setUnread(false);
            }}>
            <Tippy
              // content={`Color: ${namer(x.color).ntc[0].name}, title: ${x?.name}`}
              content={'Notifications'}
              placement="top"
              arrow={true}>
              {isUnread ? (
                <img src={bellIcon2} alt="comp1" className="notification-img" />
              ) : (
                <img src={notificationIcon} alt="comp1" className="notification-img" />
              )}
            </Tippy>
          </Dropdown.Toggle>
        </Dropdown>
        <a onClick={handleBackClick}>
          <img src={leftArrow} alt="comp1" className="left-arrow" />
        </a>
      </div>
    </>
  );

  const latestUpdate = projectData?.latestUpdate?.[0] || {};
  const status = latestUpdate?.updateStatus?.value || 'ontime';

  const isLate = status === 'late';
  const isEarly = status === 'early';

  const progress = projectData?.progress?.toFixed(0) || 0;

  const remainingDays = getRemainingDays(isLate || isEarly ? projectData?.updatedEndDate : projectData?.endDate);

  const deliveryDate = isLate || isEarly ? projectData?.updatedEndDate : projectData?.endDate;

  const statusLabel = isLate ? 'Late' : isEarly ? 'Early' : 'On-time';

  const statusColor = isLate ? '#E24A4A' : isEarly ? '#195FA4' : '#639922';

  const daysText = isEarly
    ? `${latestUpdate?.daysEarly || 0} days`
    : isLate
      ? `${latestUpdate?.daysLate || 0} days`
      : '0 days';

  const daysLabel = isEarly ? 'Ahead' : isLate ? 'Behind' : 'On track';

  const blockClosedProjectInteraction = (event) => {
    if (!isClosedProject) return;
    event.preventDefault();
    event.stopPropagation();
  };

  const blockClosedProjectKeyboardInteraction = (event) => {
    if (!isClosedProject || event.key === 'Tab') return;
    event.preventDefault();
    event.stopPropagation();
  };

  if (pageLoading) {
    return <div className="nodata-loader">{selectLoader(70)}</div>;
  }

  if (projectLoadError) {
    const errorContent = (
      <div className="main-content overview_updated">
        <section className="overview-sec">
          <div className="container project-load-error" role="alert">
            <h2>Unable to load project</h2>
            <p>{projectLoadError}</p>
            <button type="button" className="btn-black" onClick={() => fetchProjectData(projectIdRef.current || projectId)}>
              Retry
            </button>
          </div>
        </section>
      </div>
    );

    return embedded ? (
      errorContent
    ) : (
      <div className="wrapper">
        <Header content={HeaderContent} />
        {errorContent}
      </div>
    );
  }

  const mainContent = (
    <div className="main-content overview_updated">
      <section className="overview-sec">
        <div
          className={`container ${isClosedProject ? 'overview-closed-content' : ''}`}
          aria-disabled={isClosedProject}
          onClickCapture={blockClosedProjectInteraction}
          onSubmitCapture={blockClosedProjectInteraction}
          onContextMenuCapture={blockClosedProjectInteraction}
          onKeyDownCapture={blockClosedProjectKeyboardInteraction}>
          {projectData?.isDraft && (
            <div className="row">
              <div className="col-lg-12">
                <div className="overview_updated_topSec">
                  <div className="topSec_left">
                    <label>This project is currently in draft.</label>
                    <p>Set up project details, timelines, and team members before moving it forward.</p>
                  </div>
                  {hasPermission(currentUserRole, 'update_projects', memberPermission) && (
                    <button className="publish_btn" onClick={() => handleEditProject(projectData._id)}>
                      Edit & Publish
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="row align-items-start">
            <div className="col-lg-4 col-md-12">
              <div className={`left-sec-content ${projectData?.isDraft ? 'draft-overview' : ''}`}>
                {/* OptionCard updated  */}
                <div className="card-wrapper-cover">
                  <div className="option-card">
                    <div className="card-top">
                      <div>
                        <h2 className="title">{projectData?.projectName}</h2>
                        <p className="subtitle">
                          {isUser1
                            ? projectData?.organizationId?.name || projectData?.createdBy?.companyId?.name
                            : projectData?.createdBy?.companyId?.name}
                        </p>
                      </div>
                      <div className="top-actions">
                        <button className={`status-btn ${status}`}>{statusLabel}</button>
                        {SHOW_SLACK_INTEGRATION &&
                          !projectData?.isDraft &&
                          projectSlackStatusLoadedFor === projectId &&
                          (projectSlackStatus?.connected || projectSlackStatus?.hasConnectedBefore) && (
                            <img
                              src={slackIcon}
                              alt="Slack"
                              className={`project-card-slack-icon ${
                                projectSlackStatus?.connected ? 'connected' : 'disconnected'
                              }`}
                            />
                        )}
                        {hasPermission(currentUserRole, 'update_projects') &&
                          !isClosedProject &&
                          memberPermission === 'Edit' && (
                            <Dropdown align="end" onToggle={() => {}}>
                              <Dropdown.Toggle as="span" className="file_menu filemenu-progress cursor_pointer">
                                <img src={dotsThreeIcon} alt="menu" />
                              </Dropdown.Toggle>

                              <Dropdown.Menu>
                                <Dropdown.Item onClick={() => handleEditProject(projectData._id)}>
                                  {' '}
                                  <img src={editIcon} className="featherdrowpdown-icon" alt="menu" />
                                  Project settings
                                </Dropdown.Item>

                                {SHOW_SLACK_INTEGRATION && !projectData?.isDraft && (
                                  <Dropdown.Item onClick={handleProjectSlackToggle} disabled={projectSlackLoading}>
                                    <img src={slackIcon} className="featherdrowpdown-icon slack_icon" alt="Slack" />
                                    {projectSlackStatus?.connected ? 'Disconnect Slack' : 'Connect Slack'}
                                  </Dropdown.Item>
                                )}

                                {hasPermission(currentUserRole, 'update_projects', memberPermission) &&
                                !isClosedProject &&
                                !projectData?.isDraft ? (
                                  isClosingProject ? (
                                    selectLoader(20)
                                  ) : (
                                    <Dropdown.Item
                                      className="text-danger"
                                      onClick={() => toggleModal('closeConfirmModal', true)}>
                                      <img src={cross3} alt="cross3" className="featherdrowpdown-icon" />
                                      {!isAutoRenew && isRecurring ? 'Start new cycle' : 'Close project'}
                                    </Dropdown.Item>
                                  )
                                ) : null}
                              </Dropdown.Menu>
                            </Dropdown>
                          )}
                      </div>
                    </div>
                    <div className="card-middle">
                      <span className="date">{formatDate(projectData?.startDate || new Date())}</span>
                      <span className="percent">{progress}%</span>
                    </div>

                    <div className="progress-bar">
                      <div
                        className="progress-fill"
                        style={{
                          width: `${progress}%`,
                          backgroundColor: statusColor
                        }}
                      />
                    </div>

                    <div className="info-grid">
                      <div className="info-box ">
                        <h3 className="remaining-text">{remainingDays > 0 ? `${remainingDays} days` : '0 days'}</h3>
                        <p>Remaining</p>
                      </div>

                      <div className="info-box">
                        <h3 className={`highlight ${status}`}>{formatDate(deliveryDate || new Date())}</h3>
                        <p>{isLate || isEarly ? 'Est. delivery' : 'Delivery date'}</p>
                      </div>
                      {status === 'late' || status === 'early' ? (
                        <div className="info-box">
                          <h3 className={`highlight ${status}`}>{daysText}</h3>
                          <p>{daysLabel}</p>
                        </div>
                      ) : null}
                    </div>

                    <div className="card-footer">
                      {projectData?.latestUpdate[0]?.createdBy ? (
                        <>
                          Modified by {projectData?.latestUpdate[0]?.createdBy?.fullName},{' '}
                          {formatDate(projectData?.createdBy?.updatedAt || new Date())}
                        </>
                      ) : (
                        <>
                          Created by {projectData?.createdBy?.fullName},{' '}
                          {formatDate(projectData?.startDate || new Date())}
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {SHOW_SLACK_INTEGRATION &&
                  hasPermission(currentUserRole, 'update_projects', memberPermission) &&
                  currentTab === 1 &&
                  !projectData?.isDraft &&
                  projectSlackStatusLoadedFor === projectId &&
                  showProjectSlackBanner &&
                  !projectSlackStatus?.connected && (
                    <div className="project-slack-banner">
                      <div className="project-slack-banner-left">
                        <img src={slackIcon} alt="Slack"  className="filter_inherit"/>
                        <span>Slack Integration</span>
                      </div>
                      <button
                        type="button"
                        className="project-slack-banner-connect"
                        onClick={handleProjectSlackToggle}
                        disabled={projectSlackLoading}>
                        
                        {projectSlackLoading ? selectLoader(12, '0px') : <span> <img src={connectIcon} alt="Connect" className="connect-icon" /> Connect</span>}
                      </button>
                      <button
                        type="button"
                        className="project-slack-banner-close"
                        onClick={handleProjectSlackBannerClose}
                        aria-label="Close Slack integration banner">
                        ×
                      </button>
                    </div>
                  )}

                {(changeOrders?.length > 0 || changeRequests?.length > 0 || activeQuotes?.length > 0) &&
                  !projectData?.isDraft && (
                    <div className="cardBox-content-item">
                      <div className="milestone-edit">
                        <h4>Requests</h4>
                      </div>
                      {changeRequests?.length > 0 &&
                        // console.log(milestones?.changeOrderRequests)

                        changeRequests.map((req, index) => (
                          <button
                            className={`change-order-btn ${
                              calculateDateDifference(req.expireInDate, currentTime).includes('Overdue')
                                ? 'overdue'
                                : ''
                            }`}
                            key={index}
                            onClick={() => {
                              handleRequestDetails(req._id, 2);
                            }}>
                            {' '}
                            <Tippy content={req.title} placement="top" arrow={true}>
                              <span>Request: {req.title}</span>
                            </Tippy>
                            {req.changeRequestDeadlineDate && (
                              <div className="timer-text">
                                <img src={timeIcon} alt="comp1" className="time-icon" />{' '}
                                {calculateDateDifference(req.changeRequestDeadlineDate, currentTime)} {/* days */}
                                <img src={whiteArro} alt="comp1" className="right-arrow" />
                              </div>
                            )}
                            {/* <img
                              src={whiteArro}
                              alt="comp1"
                              className="right-arrow"
                            /> */}
                          </button>
                        ))}
                      {activeQuotes?.length > 0 &&
                        // console.log(milestones?.changeOrderRequests)

                        activeQuotes.map((qoute, index) => (
                          <button
                            className={`change-order-btn ${
                              calculateDateDifference(qoute.expireInDate).includes('Overdue') ? 'overdue' : ''
                            }`}
                            key={index}
                            onClick={() => {
                              handleRequestDetails(qoute.projectRequestId || qoute._id, 2);
                            }}>
                            {' '}
                            <span>Quote Given </span>
                            {qoute.expireInDate && (
                              <div className="timer-text">
                                <img src={timeIcon} alt="comp1" className="time-icon" />{' '}
                                {calculateDateDifference(qoute.expireInDate, currentTime)} {/* days */}
                                <img src={whiteArro} alt="comp1" className="right-arrow" />
                              </div>
                            )}
                            {/* <img
                              src={whiteArro}
                              alt="comp1"
                              className="right-arrow"
                            /> */}
                          </button>
                        ))}
                      {changeOrders?.length > 0 &&
                        // console.log(milestones?.changeOrderRequests)

                        changeOrders.map((order, index) => (
                          <button
                            className="change-order-btn"
                            key={index}
                            onClick={() => {
                              handleRequestDetails(order.parentRequestId || order._id, 2);
                            }}>
                            {' '}
                            <Tippy content={order.title} placement="top" arrow={true}>
                              <span>Change Order: {order.title}</span>
                            </Tippy>
                            <img src={whiteArro} alt="comp1" className="right-arrow" />
                          </button>
                        ))}
                    </div>
                  )}

                {/* Running Milestones */}
                {milestones?.running?.length > 0 && (
                  <div className="cardBox-content-item">
                    <div className={`milestone-edit ${collapsedSections.running ? 'hiden-border' : ''}`}>
                      <h4 className="collapsible-header" onClick={() => toggleSection('running')}>
                        Running Milestones
                        <span className={`arrow ${collapsedSections.running ? 'open' : ''}`}>
                          <img src={collapseIcon} alt="comp1" className="time-icon" />
                        </span>
                      </h4>
                    </div>

                    {!collapsedSections.running &&
                      milestones?.running.map((milestone) => (
                        <div key={milestone._id}>
                          <div className="design-item">
                            <p className="running-list-p" title={milestone.name}>
                              {milestone.name}
                            </p>

                            {!projectData?.isDraft && milestone.dueDate && (
                              <>
                                <span>&nbsp;</span>
                                <small className="date-diff">
                                  {calculateDateDifference(milestone.dueDate, currentTime)}
                                </small>
                              </>
                            )}
                            {isUser1 &&
                              !projectData?.isDraft &&
                              !isClosedProject &&
                              hasPermission(currentUserRole, 'edit_milestones', memberPermission) &&
                              (loadingMilestoneId === milestone._id ? (
                                selectLoader(20)
                              ) : (
                                <small
                                  className="cursor_pointer ml-3   update-status"
                                  onClick={() => {
                                    updateMilestoneStatus(milestone._id, 'complete');
                                  }}>
                                  End
                                </small>
                              ))}
                          </div>

                          {/* <div className="design-progress-item">
                            <ProgressBar now={milestone.percentage} />
                            <span className="percentage">
                              {milestone.percentage}%
                            </span>
                          </div> */}
                          {milestone.signoffRequest && !projectData?.isDraft && (
                            <button
                              onClick={() => {
                                handleRequestDetails(milestone.signoffRequest._id, 2);
                              }}
                              className={`signoff-request-btn ${
                                calculateDateDifference(milestone.signoffDeadline, currentTime).includes('Overdue') &&
                                milestone.signOffTime !== 0
                                  ? 'overdue'
                                  : ''
                              }`}>
                              Sign-off{' '}
                              {hasPermission(currentUserRole, 'send_signoff_requests')
                                ? calculateDateDifference(milestone.signoffDeadline, currentTime).includes('Overdue') &&
                                  milestone.signOffTime !== 0
                                  ? ' Delayed'
                                  : 'Request Sent'
                                : 'Request Received'}
                              {milestone.signOffTime !== 0 && (
                                <div className="timer-text">
                                  <img src={timeIcon} alt="comp1" className="time-icon" />{' '}
                                  {calculateDateDifference(milestone.signoffDeadline, currentTime)?.replace(
                                    'Overdue',
                                    ''
                                  )}{' '}
                                  {/* days */}
                                  <img src={whiteArro} alt="comp1" className="right-arrow" />
                                </div>
                              )}
                            </button>
                          )}
                        </div>
                      ))}
                  </div>
                )}

                {/* Upcoming Milestones */}
                {milestones?.upcoming?.length > 0 && (
                  <div className="cardBox-content-item">
                    <div className={`milestone-edit ${collapsedSections.upcoming ? 'hiden-border' : ''}`}>
                      <h4 className="collapsible-header" onClick={() => toggleSection('upcoming')}>
                        Upcoming Milestones
                        <span className={`arrow ${collapsedSections.upcoming ? 'open' : ''}`}>
                          <img src={collapseIcon} alt="comp1" className="time-icon" />
                        </span>
                      </h4>
                    </div>

                    <div className="skill-rols-list-cover">
                      {!collapsedSections.upcoming &&
                        milestones?.upcoming.map((milestone) => (
                          <div key={milestone._id} className="skill-rols-list">
                            <p title={milestone.name}>{milestone.name}</p>
                            {isUser1 &&
                              !projectData?.isDraft &&
                              !isFutureProject &&
                              !isClosedProject &&
                              hasPermission(currentUserRole, 'edit_milestones', memberPermission) &&
                              (loadingMilestoneId === milestone._id ? (
                                selectLoader(20)
                              ) : (
                                <small
                                  className="cursor_pointer update-status"
                                  onClick={() => {
                                    updateMilestoneStatus(milestone._id);
                                  }}>
                                  Start
                                </small>
                              ))}
                          </div>
                        ))}
                    </div>
                  </div>
                )}

                {/* Completed milestones */}
                {milestones?.completed?.length > 0 && (
                  <div className="cardBox-content-item">
                    <div className={`milestone-edit ${collapsedSections.completed ? 'hiden-border' : ''}`}>
                      <h4 className="collapsible-header" onClick={() => toggleSection('completed')}>
                        Completed Milestones
                        <span className={`arrow ${collapsedSections.completed ? 'open' : ''}`}>
                          <img src={collapseIcon} alt="comp1" className="time-icon" />
                        </span>
                      </h4>
                    </div>

                    <div className="skill-rols-list-cover">
                      {!collapsedSections.completed &&
                        Object.entries(groupMilestonesByMonth(milestones.completed))
                          .sort((a, b) => new Date(b[1].date) - new Date(a[1].date)) // 🔥 latest first
                          .map(([key, group]) => (
                            <div key={key}>
                              {/* Month divider */}
                              <div className="month-year-cover">
                                <span className="bodr-left">&nbsp;</span>
                                <p>{group.label}</p>
                                <span className="bodr-right">&nbsp;</span>
                              </div>

                              {/* Milestones */}
                              {group.items
                                .sort(
                                  (a, b) => new Date(b.signoffDate || b.endDate) - new Date(a.signoffDate || a.endDate)
                                ) // optional: newest first inside month
                                .map((milestone) => (
                                  <div key={milestone._id} className="skill-rols-list">
                                    <div className="skill-rols-list-content pb-1">
                                      <p>{milestone.name}</p>
                                    </div>

                                    <p className="calender-date-text">
                                      {formatDate(
                                        milestone.signoffDate || milestone.endDate || new Date(),
                                        true,
                                        store.currentDateFormat?.toUpperCase()
                                      )}
                                    </p>
                                  </div>
                                ))}
                            </div>
                          ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="col-lg-8 col-md-12">
              <div className={`right-sec-content `}>
                <ul className="nav nav-pills" id="pills-tab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${currentTab == 1 ? 'active' : ''}`}
                      id="pills-updated-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-updated"
                      type="button"
                      role="tab"
                      aria-controls="pills-updated"
                      aria-selected="false"
                      onClick={() => {
                        setCurrentTab(1);
                      }}>
                      Activity
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${currentTab == 2 ? 'active' : ''} ${
                        projectData?.isDraft ? 'disabled-tab' : ''
                      }`}
                      id="pills-requests-tab"
                      data-bs-toggle={!projectData?.isDraft ? 'pill' : undefined}
                      data-bs-target={!projectData?.isDraft ? '#pills-requests' : undefined}
                      type="button"
                      role="tab"
                      aria-controls="pills-requests"
                      aria-selected="true"
                      onClick={() => {
                        if (!projectData?.isDraft) {
                          setCurrentTab(2);
                          setActiveView('requestList');
                          setSelectedReqId('');
                        }
                      }}>
                      {/* <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22.999"
                          height="19.532"
                          viewBox="0 0 22.999 19.532"
                        >
                          <g
                            id="Group_599"
                            data-name="Group 599"
                            transform="translate(4 2)"
                          >
                            <path
                              id="Icon_awesome-exchange-alt"
                              data-name="Icon awesome-exchange-alt"
                              d="M0,7.874V7.312a.844.844,0,0,1,.844-.844H13.5V4.78a.844.844,0,0,1,1.44-.6L17.753,7a.844.844,0,0,1,0,1.193L14.94,11a.844.844,0,0,1-1.44-.6V8.718H.844A.844.844,0,0,1,0,7.874Zm17.156,5.344H4.5V11.53a.844.844,0,0,0-1.44-.6L.247,13.746a.844.844,0,0,0,0,1.193L3.06,17.752a.844.844,0,0,0,1.44-.6V15.468H17.156A.844.844,0,0,0,18,14.624v-.562A.844.844,0,0,0,17.156,13.218Z"
                              transform="translate(0.999 -0.468)"
                              fill="#8f8f8f"
                            />
                            <g
                              id="Ellipse_84"
                              data-name="Ellipse 84"
                              transform="translate(-4 -2)"
                              fill="red"
                              stroke="#fff"
                              strokeWidth="0.5"
                            >
                              <circle cx="5" cy="5" r="5" stroke="none" />
                              <circle cx="5" cy="5" r="4.75" fill="none" />
                            </g>
                          </g>
                        </svg> */}
                      Request
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${currentTab == 3 ? 'active' : ''} ${
                        projectData?.isDraft ? 'disabled-tab' : ''
                      }`}
                      id="pills-work-tab"
                      data-bs-toggle={!projectData?.isDraft ? 'pill' : undefined}
                      data-bs-target={!projectData?.isDraft ? '#pills-work' : undefined}
                      type="button"
                      role="tab"
                      aria-controls="pills-work"
                      aria-selected="true"
                      onClick={() => {
                        if (!projectData?.isDraft) {
                          setCurrentTab(3);
                        }
                      }}>
                      Scope of Work
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${currentTab == 4 ? 'active' : ''} ${
                        projectData?.isDraft ? 'disabled-tab' : ''
                      }`}
                      id="pills-feedback-tab"
                      data-bs-toggle={!projectData?.isDraft ? 'pill' : undefined}
                      data-bs-target={!projectData?.isDraft ? '#pills-feedback' : undefined}
                      type="button"
                      role="tab"
                      aria-controls="pills-feedback"
                      aria-selected="true"
                      onClick={() => {
                        if (!projectData?.isDraft) {
                          setCurrentTab(4);
                          console.log('feedback tab click', selectedReqId);
                          setSelectedReqId('');
                        }
                      }}>
                      Feedback
                    </button>
                  </li>
                </ul>
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className={`tab-pane fade ${currentTab == 1 ? 'show active' : ''} ${projectData?.isDraft ? 'draft-overview' : ''}`}
                    id="pills-updated"
                    role="tabpanel"
                    aria-labelledby="pills-updated-tab">
                    <ActivityTab
                      setCurrentTab={setCurrentTab}
                      currentTab={currentTab}
                      updateProjectDetails={() => fetchProjectData(projectId)}
                      projectId={projectId}
                      setSelectedReqId={setSelectedReqId}
                      memberPermission={memberPermission}
                      userRole={currentUserRole}
                      isInternalProject={isInternalProject}
                      isFutureProject={isFutureProject}
                      isDraftProject={projectData?.isDraft || false}
                      projectTeam={projectTeam}
                    />
                  </div>
                  <div
                    className={`tab-pane fade ${currentTab == 2 ? 'show active' : ''} ${projectData?.isDraft ? 'draft-overview' : ''}`}
                    id="pills-requests"
                    role="tabpanel"
                    aria-labelledby="pills-requests-tab">
                    <RequestTab
                      projectId={projectId}
                      currentTab={currentTab}
                      selectedReqId={selectedReqId}
                      setSelectedReqId={setSelectedReqId}
                      activeTabView={activeTabView}
                      setActiveView={setActiveView}
                      setCurrentTab={setCurrentTab}
                      setUpdateDetails={() => {
                        setUpdateDetails((prev) => !prev);
                      }}
                      memberPermission={memberPermission}
                      userRole={currentUserRole}
                      isInternalProject={isInternalProject}
                      projectTeam={projectTeam}
                    />
                  </div>
                  <div
                    className={`tab-pane fade ${currentTab == 3 ? 'show active' : ''} ${projectData?.isDraft ? 'draft-overview' : ''}`}
                    id="pills-work"
                    role="tabpanel"
                    aria-labelledby="pills-work-tab">
                    <div
                      className={`card-body-content pills-card-body-content ${projectData?.isDraft ? 'draft-overview' : ''}`}>
                      <UpdatedScope
                        scopeData={scopeData}
                        // projectDetails={projectDetails}
                        loading={loading}
                      />
                    </div>
                  </div>
                  <div
                    className={`tab-pane fade ${currentTab == 4 ? 'show active' : ''} ${projectData?.isDraft ? 'draft-overview' : ''}`}
                    id="pills-feedback"
                    role="tabpanel"
                    aria-labelledby="pills-feedback-tab">
                    {/* <div className="text-center mt-3 milestones-comming-soon">
                        <p>Coming soon...</p>
                      </div> */}
                    <FeedbackTab
                      selectedReqId={selectedReqId}
                      projectId={projectId}
                      currentTab={currentTab}
                      activeTabView={activeTabView}
                      setActiveView={setActiveView}
                      memberPermission={memberPermission}
                      userRole={currentUserRole}
                      isInternalProject={isInternalProject}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Modal Component */}
      <SidebarModal
        extraClass={'edit-profile-modal notification-modal'}
        show={modals.notifications}
        onHide={() => toggleModal('notifications', false)}
        headerTitle={'Happy Ending Project'}>
        <Notifications closeModal={() => toggleModal('notifications', false)} />
      </SidebarModal>

      {/* <SidebarModal
        extraClass={'edit-profile-modal'}
        show={modals.signOffModal}
        onHide={() => {
          toggleModal('signOffModal', false);
          setClosedMilestoneId('');
        }}
        headerTitle={'Sign-off Request'}> */}
      <ModalCenter
        extraClass={'updatedSignOff-modal'}
        show={modals.signOffModal}
        headerTitle={'Sign-off Request'}
        closeModal={() => {
          toggleModal('signOffModal', false);
        }}>
        <SignOffForm
          projectId={projectId}
          updatedMilestoneId={closedMilestoneId}
          closeModal={() => {
            updateandCloseModal('signOffModal');
            setClosedMilestoneId('');
          }}
        />
      </ModalCenter>
      {/* // </SidebarModal> */}
      <ConfirmModal
        show={modals.closeConfirmModal}
        onHide={() => {
          toggleModal('closeConfirmModal', false);
        }}
        confirmationText={closeConfirmContent}
        handleNo={() => {
          if (!isAutoRenew && isRecurring) {
            handleCloseProject(false);
          } else {
            toggleModal('closeConfirmModal', false); // just close modal
          }
        }}
        handleAction={() => {
          if (!isAutoRenew && isRecurring) {
            handleCloseProject(true);
          } else {
            handleCloseProject(); // for non-recurring
          }
        }} // Pass the deletion logic here
        isRecurring={(!isAutoRenew && isRecurring) || false}
        loading={isClosingProject}
        closeText="Yes"
        showNoButton={(!isAutoRenew && isRecurring) || false}
        bgClassname={!isAutoRenew && isRecurring ? 'close_cofirm_recurring' : 'confirm_close'}
      />
    </div>
  );

  return embedded ? (
    mainContent
  ) : (
    <div className="wrapper">
      <Header content={HeaderContent} />
      {mainContent}
    </div>
  );
};

export default UpdatedOverview;
